export enum ReeferOperatingModeCategory {
    Unknown = -1,
    StartStop = 0,
    Continuous = 1,
    CycleSentry = 2
}
